<div>
    <app-printer-toast (onConfirmation)="routeToWallpaper()" [toastData]="showToast$|async"></app-printer-toast>
    <router-outlet #outlet="outlet"></router-outlet>
</div>